// extracted by mini-css-extract-plugin
export default {"wrapper":"EditBox_wrapper__UqK28"};